module.exports = __webpack_public_path__ + "img/c783fad.jpg";